module.exports = __webpack_public_path__ + "static/media/Vistahome_compendio_.84fb0073.png";